// analytics/posthog — inizializzazione PostHog flag-gated + helper.
//
// Attivo SOLO se GATSBY_POSTHOG_KEY è valorizzato (come il token Mapbox): env
// vuota = PostHog spento, zero impatto. Cloud EU. Session replay con masking dei
// campi sensibili (tutti gli input → P.IVA/IBAN/importi digitati mascherati).
//
// Consenso cookie: se il banner è attivo (GATSBY_FEATURE_COOKIE_BANNER) PostHog
// parte in opt-out finché l'utente non accetta; se il banner è disattivo (default)
// cattura da subito. Il consenso è salvato in localStorage.

import posthog from 'posthog-js';

const KEY = process.env.GATSBY_POSTHOG_KEY || '';
const HOST = process.env.GATSBY_POSTHOG_HOST || 'https://eu.i.posthog.com';
const BANNER_ON = ['true', '1'].includes(String(process.env.GATSBY_FEATURE_COOKIE_BANNER || '').toLowerCase());
const CONSENT_KEY = 'iot_cookie_consent'; // 'accepted' | 'declined'

export const posthogEnabled = () => !!KEY;
export const cookieBannerEnabled = () => BANNER_ON;
export const getConsent = () => {
  try { return typeof window !== 'undefined' ? localStorage.getItem(CONSENT_KEY) : null; } catch { return null; }
};

let started = false;

export function initPostHog() {
  if (started || !KEY || typeof window === 'undefined') return;
  started = true;
  // Con banner attivo e senza consenso → parti disattivato (opt-out).
  const needConsent = BANNER_ON && getConsent() !== 'accepted';
  posthog.init(KEY, {
    api_host: HOST,
    person_profiles: 'identified_only',
    capture_pageview: true,
    autocapture: true,
    opt_out_capturing_by_default: needConsent,
    session_recording: {
      maskAllInputs: true,               // maschera TUTTI gli input (P.IVA, IBAN, importi…)
      maskTextSelector: '[data-ph-mask]', // maschera anche il testo marcato con questo attributo
    },
  });
}

// ── Consenso cookie ───────────────────────────────────────────────────────────
export function acceptCookies() {
  try { localStorage.setItem(CONSENT_KEY, 'accepted'); } catch { /* no-op */ }
  if (KEY) { try { posthog.opt_in_capturing(); } catch { /* no-op */ } }
}
export function declineCookies() {
  try { localStorage.setItem(CONSENT_KEY, 'declined'); } catch { /* no-op */ }
  if (KEY) { try { posthog.opt_out_capturing(); } catch { /* no-op */ } }
}

// ── Helper analytics (no-op se PostHog è spento) ──────────────────────────────
export function phIdentify(uid, props) { if (KEY && uid) { try { posthog.identify(uid, props); } catch { /* no-op */ } } }
export function phGroup(tenantId) { if (KEY && tenantId) { try { posthog.group('tenant', tenantId); } catch { /* no-op */ } } }
export function phReset() { if (KEY) { try { posthog.reset(); } catch { /* no-op */ } } }
export function phCapture(event, props) { if (KEY) { try { posthog.capture(event, props); } catch { /* no-op */ } } }
